import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80px;\n    height: 80px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  0% {\n\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100px;\n  height: 100px;\n  border-radius: 999px;\n  border: 3px solid #34f5ae;\n  border-top-color: transparent;\n  animation: ",
        " 1s linear infinite forwards;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled, { keyframes } from "styled-components";
import MummyIcon from "./MummyIcon";
var Container = styled.div.withConfig({
    componentId: "sc-5e4aa583-0"
})(_templateObject());
var loading = keyframes(_templateObject1());
var Loader = styled.div.withConfig({
    componentId: "sc-5e4aa583-1"
})(_templateObject2(), loading);
var Spinner = function() {
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            /*#__PURE__*/ _jsx(Loader, {}),
            /*#__PURE__*/ _jsx(MummyIcon, {})
        ]
    });
};
export default Spinner;
